/**
 * Must-use 標記 ＋ 標記模式（UI v2 步 6：由 `ChatPage.tsx` 抽出，零行為改動）
 *
 * ⚠️ 標記**按對話保存**（`cosingery.pinned.<sessionId>`；`decisions/026`）。
 */
import { useEffect, useState } from 'react';

export type MustUseMode = 'exact' | 'meaning';
export interface MustUseItem {
  text: string;
  mode: MustUseMode;
}

export function useMustUse(sessionId: string) {
  const [pinned, setPinned] = useState<MustUseItem[]>([]);
  /** ⭐ 標記模式（由 composer ＋ 訊息揀句共用；`decisions/026`） */
  const [armed, setArmed] = useState<MustUseMode | null>(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(`cosingery.pinned.${sessionId}`);
      setPinned(raw ? (JSON.parse(raw) as MustUseItem[]) : []);
    } catch {
      setPinned([]);
    }
  }, [sessionId]);

  useEffect(() => {
    try {
      localStorage.setItem(`cosingery.pinned.${sessionId}`, JSON.stringify(pinned));
    } catch {
      /* 私隱模式 */
    }
  }, [pinned, sessionId]);

  return { pinned, setPinned, armed, setArmed };
}
